$(document).ready(function () {
    let path = window.location.pathname;

    if (path.indexOf('/properties/buy') === 0) {
        $("#buy").addClass("active");
    } else if (path.indexOf('/properties/rent') === 0) {
        $("#rent").addClass("active");
    }

    $(document).on("click", "#buy", function () {
        $("#buy").addClass("active");
        $("#rent").removeClass("active");
    });

    $(document).on("click", "#rent", function () {
        $("#rent").addClass("active");
        $("#buy").removeClass("active");
    });

    if (path.indexOf('/properties/buy/residential') === 0 || path.indexOf('/properties/rent/residential') === 0 || path.indexOf('/off-market-sales/residential') === 0) {
        $("#residential").addClass("active");
    } else if (path.indexOf('/properties/buy/commercial') === 0 || path.indexOf('/properties/rent/commercial') === 0 || path.indexOf('/off-market-sales/commercial') === 0) {
        $("#commercial").addClass("active");
    }

    $(document).on("click", "#residential", function () {
        $("#residential").addClass("active");
        $("#commercial").removeClass("active");
    });

    $(document).on("click", "#commercial", function () {
        $("#commercial").addClass("active");
        $("#residential").removeClass("active");
    });
});